import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import ReactModalFooter from '../Modal/ReactModalFooter';
import { modalActions, inputTilesActions } from '../../redux/root-action';
import { scroller } from 'react-scroll';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { isMobileApp, getDomain } from '../../utils/api';
import { modals } from '../../utils/constants';
import { keyDown } from '../../utils/helpers';

const StyledHeaderText = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey800};
  padding-top: 16px;
`;

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey900};
  margin: 16px 0px 56px 0px;
`;

class ConfidenceNumber extends Component<any, any> {
  handleLearnMoreClick = () => {
    const { hideModal, showModal } = this.props;
    const element = document.getElementById('rix-assumptions-text-open');
    if (isMobileApp()) {
      showModal(modals.RIX_ASSUMPTIONS);
    } else {
      window.location.href = getDomain() + '/workplace/en/participant/home/methodology-and-assumptions.html';
    }
  };

  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Confidence Number'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            <StyledHeaderText>How do we determine your Confidence Number?</StyledHeaderText>
            Your Confidence Number is the likelihood your savings will last through your retirement.
            <StyledHeaderText>We estimate what you&#39;ll need.</StyledHeaderText>
            Unless you&#39;ve entered a Retirement Income Goal, we estimate the percentage of your current salary
            required to maintain your lifestyle in retirement, which could last 30 years or more.This amount is based on
            your spending needs. Higher withdrawal amounts may be necessary due to withholding requirements or the need
            to pay taxes.
            <br />
            <br />
            To calculate your income goal (shown in today&#39;s dollars) we subtract certain estimated taxes (state,
            federal and employment taxes) and any regular contributions made to your account(s) from
            your projected salary at retirement. Then we estimate how long your savings will last if you live off your
            Retirement Income Goal.
            <StyledHeaderText>Then we estimate what you&#39;ll have.</StyledHeaderText>
            To generate your Confidence Number, we run your salary, retirement age, and account information through 500
            market scenarios. Our calculation estimates the percentage of times you&#39;ll have enough to meet your
            Retirement Income Goal throughout retirement. If you end up with enough money in 70% of the scenarios, your
            Confidence Number will be 70. 
            <Link
              linkLabel="Learn more about the methodology and assumptions used to calculate your
            Confidence Number."
              customStyles={'font-family: Nimbus Sans Bold; display: inline'}
              onClick={this.handleLearnMoreClick}
              underline={true}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleLearnMoreClick)}
            />
            <StyledHeaderText>What&#39;s a good Confidence Number?</StyledHeaderText>
            If your Confidence Number is above 80, you&#39;re on track to meet your financial goals in retirement. If
            it&#39;s less than 80, you may want to consider making some adjustments. You can see the impact of any
            adjustments in our Retirement Income Planner.
          </StyledText>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Learn More"
          hideCancel={true}
          buttonType="textButton"
          handleCTAClick={this.handleLearnMoreClick}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
  showInputTilePopover: inputTilesActions.showInputTilePopover,
})(ConfidenceNumber);
